export const postToOpener = (type: string, params = {}) => {
  window.opener?.postMessage({ type, ...params }, window.location.origin);
};
